import type { Resource } from '../../';
export const header_utilBar_storeLocator: Resource = {"default":"Store Locator"};
